import { put, select } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { newMessageEvent } from 'rdx/modules/messages/slice';
import { getWorkflowRaw, getWorkflow } from 'rdx/modules/workflow/slice';

function* resumeTrial({ payload }) {
  const { success, data, error } = yield* makeRequest.patch(payload.link);
  if (success && data) {
    yield payload.requestStep();
    yield put(newMessageEvent({ text: 'Step Resumed' }));
    const workflow = yield select(getWorkflowRaw);
    yield put(getWorkflow(workflow.links.self));
  } else {
    yield* putErrorActions({ error });
  }
  return null;
}

export default resumeTrial;
